<tdv-upload-resource-progress-header
  *ngIf="items?.length > 1"
  [items]="items"
  [isFullView]="showFullView"
  class="flex justify-between items-center rounded-16 px-16 py-12 h-36 cursor-pointer"
  [ngClass]="[
    showFullView && items?.length !== 1
      ? 'bg-gray-300 bg-opacity-5'
      : 'bg-work-area',
  ]"
  (click)="showFullView = !showFullView"
></tdv-upload-resource-progress-header>

<div
  *ngIf="showFullView || items?.length === 1"
  class="items-wrap overflow-y-auto"
>
  <tdv-upload-resource-progress-item
    *ngFor="let item of items; trackBy: trackById"
    [item]="item"
    [progress]="item.progressForUploadBlobWatcher.$ | async"
    class="flex justify-between items-center p-12"
  >
  </tdv-upload-resource-progress-item>
</div>

<tdv-upload-resource-progress-total
  *ngIf="!showFullView && items?.length > 1"
  [items]="items"
></tdv-upload-resource-progress-total>
